import { withTitle } from '@gik/core/hocs/withTitle';
import { CreatePage } from '@gik/create/components/CreatePage/CreatePage';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';

export default function CreatePageComp() {
  return withTitle('Create', <CreatePage />);
}

CreatePageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};
